import Typography from "@portal/components/atoms/v2/typography";
import { RadioGroup } from "@headlessui/react";

import RadioComponentWithSelectionBox from "@portal/components/atoms/v2/radioComponentWithSelectionBox";

interface Props {
  options: string[];
  selectedOption: number | null;
  onSelectionClick: (selectedOption: number) => void;
}

/**
 * Component for the user choices for a page in the savings robot.
 * @param params
 * @returns clickable boxes.
 */
export const SelectionBoxComponent = ({ options, selectedOption, onSelectionClick }: Props) => (
  <div className="flex flex-col mt-3 w-full">
    <RadioGroup value={selectedOption ?? undefined} onChange={onSelectionClick} className="space-y-3">
      {options.map((text, i) => (
        <RadioComponentWithSelectionBox key={i} id={`${i}`} value={i}>
          <div className="flex flex-col p-1">
            <Typography variant={"Body"}>{text}</Typography>
          </div>
        </RadioComponentWithSelectionBox>
      ))}
    </RadioGroup>
  </div>
);
